import axios from 'axios'
import { identity } from 'lodash'
import { setAuthorizationHeader } from '../utils/authorizationUtils'
import { kakaoLogout } from '../features/login/kakaoAccount'
import { AD_PLATFORM_TYPE } from '../features/crux/cruxConstants'

const { REACT_APP_CRUX_API_HOST, NODE_ENV } = process.env

export const fokaAxios = axios.create({
  baseURL: `${REACT_APP_CRUX_API_HOST}/keywordad`,
  withCredentials: true,
})
fokaAxios.interceptors.request.use(config => {
  config.headers.set('serviceType', AD_PLATFORM_TYPE)
  return setAuthorizationHeader(config)
}, identity)

fokaAxios.interceptors.response.use(identity, error => {
  const status = error.response?.status
  const errorCode = error.response?.data?.errorCode
  const errorMessage = error.response?.data?.errorMessage

  if (NODE_ENV === 'development') {
    console.error({
      status,
      data: error.response?.data,
    })
  }

  if (status === 401) {
    kakaoLogout()
    return
  }

  if (status === 403 || status === 423) {
    window.location.href = '/error/401'
    return
  }

  if (errorCode) {
    error.code = errorCode
  }
  if (errorMessage) {
    error.message = errorMessage
  }
  return Promise.reject(error)
})
